import React, { useState } from "react";
import storageManager from "./Utility/StorageManager";

export const FilterContext = React.createContext();

const FilterContextProvider = ({ children }) => {
  const [filterData, setFilterData] = useState({
    artist_id: storageManager.getItem("artist_id") || "",
    artist_name: storageManager.getItem("artist_name") || "",
    event_id: storageManager.getItem("event_id") || "",
    previous_event_id: storageManager.getItem("previous_event_id") || "",
    date_button: storageManager.getItem("date_button") || "",
    start_date: storageManager.getItem("start_date") || "",
    end_date: storageManager.getItem("end_date") || "",
  });

  const setFilter = (data) => {
    storageManager.setItem("artist_id", data.artist_id);
    storageManager.setItem("artist_name", data.artist_name);
    storageManager.setItem("event_id", data.event_id);
    storageManager.setItem("previous_event_id", data.previous_event_id);
    storageManager.setItem("date_button", data.date_button);
    storageManager.setItem("start_date", data.start_date);
    storageManager.setItem("end_date", data.end_date);
    setFilterData({
      artist_id: storageManager.getItem("artist_id"),
      artist_name: storageManager.getItem("artist_name"),
      event_id: storageManager.getItem("event_id"),
      previous_event_id: storageManager.getItem("previous_event_id"),
      date_button: storageManager.getItem("date_button"),
      start_date: storageManager.getItem("start_date"),
      end_date: storageManager.getItem("end_date"),
    });
  };

  return (
    <FilterContext.Provider
      value={{
        filterData,
        setFilterData: setFilter,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export default FilterContextProvider;
